import { type PropsWithChildren } from "react";

export function MainMetricSummarySection({
  children,
}: PropsWithChildren<object>) {
  return (
    <div className="h-[76px] w-full border-b border-v2-secondary flex items-start self-stretch">
      {children}
    </div>
  );
}
